import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../shared/services/modal.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SampleService } from '../../core/http/sample.service';
import { SettingsService } from '../../core/http/settings.service';
import { BillingService } from '../../core/http/billing.service';
import { AuthServiceService } from '../../core/http/auth-service.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SampleCollectModalComponent } from '../../shared/components/sample-collect-modal/sample-collect-modal.component';
import { SampleAcknoledgeModalComponent } from '../../shared/components/sample-acknoledge-modal/sample-acknoledge-modal.component';
import { BarcodeComponent } from '../../shared/components/barcode/barcode.component';
import {
  trigger,
  style,
  animate,
  transition,
  state,
} from '@angular/animations';
import * as _moment from 'moment';
const moment = _moment;

@Component({
  selector: 'app-patient-bills',
  templateUrl: './patient-bills.component.html',
  styleUrls: ['./patient-bills.component.scss'],
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({ transform: 'translateY(-100%)' }),
        animate('200ms ease-in', style({ transform: 'translateY(0%)' })),
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ transform: 'translateY(-100%)' })),
      ]),
    ]),
  ],
})
export class PatientBillsComponent implements OnInit {
  isLoading = true;
  Errors = null;
  data: any = [];
  samples: any = [];
  encounters: any = [];
  services: any = [];
  Success;
  billId;
  message;
  startdate = localStorage.getItem('startdate');
  enddate = localStorage.getItem('enddate');
  sd;
  ed;
  is_verified = JSON.parse(localStorage.getItem('verified'));
  dept_code = JSON.parse(localStorage.getItem('dept_code'));
  sub_dept_code = JSON.parse(localStorage.getItem('sub_dept_code'));
  investigation = '';
  name = '';
  gender = '';
  phone = '';
  is_finalized = JSON.parse(localStorage.getItem('finalize'));
  is_acknowledged = JSON.parse(localStorage.getItem('is_acknowledged'));
  is_collected = JSON.parse(localStorage.getItem('is_collected'));
  depts: any = [];
  subDepts: any = [];
  investigatonList: any = [];
  drVisible: boolean = false;
  filterddata: any = [];
  items: any = [];
  vissible = false;
  startLoading = false;
  statResult;
  clickedId;
  collect = '';
  acknowledge = '';
  type = '';
  finalize = '';
  verified = '';
  online = '';
  printed = '';
  reception = '';
  patient = '';
  resultRoute = false;
  collectRoute = false;
  acknoledgeRoute = false;
  finalizeRoute = false;
  acknowledgeRoute = false;
  printRoute = false;
  patientName = '';
  page;
  verif: any = [];
  // filter = 'bills';
  filter = 'bills';
  is_printed = -1;
  is_online = -1;
  is_dispatched = -1;
  is_final = -1;
  currentDateTime = new Date();

  stateForm = new FormGroup({
    id: new FormControl('', Validators.required),
    bill_id: new FormControl('', Validators.required),
    is_collect_action: new FormControl('', Validators.required),
    is_acknowledge_action: new FormControl('', Validators.required),
  });

  constructor(
    public router: Router,
    private sample: SampleService,
    private modal: ModalService,
    private _snackBar: MatSnackBar,
    public setting: SettingsService,
    public auth: AuthServiceService,
    public bill: BillingService
  ) {}

  ngOnInit(): void {
    console.log(this.router.url);
    console.log(this.startdate, this.enddate);
    let lastMonth = moment().subtract('months', 1).format();
    console.log(lastMonth);
    this.sd = new Date(this.startdate ?? lastMonth.split('T')[0]);
    this.ed = new Date(this.enddate ?? new Date().toISOString().split('T')[0]);
    this.page = this.router.url;

    this.verif = [
      { name: 'Yes', value: 1 },
      { name: 'No', value: 0 },
      { name: 'All', value: -1 },
    ];
    // this.sd = JSON.parse(localStorage.getItem('sd'), this.dateTimeReviver);

    this.getResult();
    this.searchEcounters();

    // this.bill
    //   .getEncounters()
    //   .subscribe(
    //     (resSuccess) => {
    //       this.encounters = resSuccess.filter(t => t.Recd_Payment == "Yes")
    //       this.isLoading = false
    //       console.log(resSuccess)
    //     },
    //     (resErr) => {
    //       this.isLoading = false;
    //       this.Errors = resErr;
    //     }
    //   )

    this.setting.getDept().subscribe(
      (resSuccess) => {
        this.depts = resSuccess;
        console.log(resSuccess);
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );
    this.setting.getSubDept().subscribe(
      (resSuccess) => {
        this.subDepts = resSuccess;
        console.log(resSuccess);
      },
      (resErr) => {
        this.isLoading = false;
      }
    );

    this.setting.getItems().subscribe(
      (resSuccess) => {
        this.items = resSuccess;
        // this.filterddata = this.items
        this.isLoading = false;
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );
  }

  verify(event) {
    localStorage.setItem('verified', event.value);
    console.log(this.is_verified);
  }
  finalized(event) {
    localStorage.setItem('finalize', event.value);
    console.log(this.is_finalized);
  }

  dept(event) {
    localStorage.setItem('dept_code', event.value);
    console.log(this.dept_code);
  }
  sub(event) {
    localStorage.setItem('sub_dept_code', event.value);
    console.log(this.sub_dept_code);
  }
  acknowledged(event) {
    localStorage.setItem('is_acknowledged', event.value);
    console.log(this.is_acknowledged);
  }

  collected(event) {
    localStorage.setItem('is_collected', event.value);
    console.log(this.collected);
  }
  isfinal(event) {
    localStorage.setItem('is_final', event.value);
    console.log(this.collected);
  }

  startDateChange(event: any) {
    this.startdate = moment(event.target.value).format('YYYY-MM-DD');
    localStorage.setItem('startdate', this.startdate);
  }
  endDateChange(event: any) {
    this.enddate = moment(event.target.value).format('YYYY-MM-DD');
    localStorage.setItem('enddate', this.enddate);
    console.log(this.enddate);
  }

  itemChange(value) {
    if (value == '') {
      this.drVisible = false;
    } else {
      this.drVisible = true;
    }
    this.filterddata = this.items.filter(
      (t) => t.name.toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
    console.log(value);
  }

  setitem(item) {
    this.investigation = item.name;
    console.log(this.investigation);

    this.drVisible = false;
  }

  getRowClass(item: any): string {
    const collected = item.service.collected
      ? item.service.collected === 'Y'
      : false;
    const acknowledged = item.service.acknowledged
      ? item.service.acknowledged === 'Y'
      : false;
    const typed = item.service.prepared ? item.service.prepared === 'Y' : false;
    const verified = item.service.verified
      ? item.service.verified === 'Y'
      : false;
    const finalized = item.service.finalized_timestamp
      ? item.service.finalized_timestamp
      : false;
    const printed = item.service.printed ? item.service.printed === 'Y' : false;

    // Priority is defined by the order of these conditions
    if (printed) return 'printed';
    if (finalized) return 'finalized';
    if (verified) return 'verified';
    if (typed) return 'prepared';
    if (acknowledged) return 'acknowledged';
    if (collected) return 'collected';

    return '';
  }

  searchEcounters() {
    this.isLoading = true;
    if (this.filter == 'bills') {
      this.encounters = [];
      this.bill
        .searchEncounters(
          this.startdate,
          this.enddate,
          this.dept_code,
          this.sub_dept_code,
          this.investigation,
          this.name,
          this.gender,
          this.phone,
          this.is_verified,
          this.is_finalized,
          this.is_collected,
          this.is_acknowledged,
          -1
        )
        .subscribe(
          (resSuccess) => {
            this.encounters = resSuccess.data.filter((t) => t.Recd_Payment == 'Yes');
            this.isLoading = false;
            console.log(resSuccess);
          },
          (resErr) => {
            this.isLoading = false;
            this.Errors = resErr;
          }
        );
    } else {
      this.services = [];
      this.bill
        .searchEncounterServices(
          this.startdate,
          this.enddate,
          this.dept_code,
          this.sub_dept_code,
          this.investigation,
          this.name,
          this.gender,
          this.phone,
          this.is_verified,
          this.is_finalized,
          this.is_collected,
          this.is_acknowledged,
          this.is_printed,
          this.is_dispatched,
          this.is_online,
          this.is_final,
          -1
        )
        .subscribe(
          (resSuccess) => {
            this.services = resSuccess.data; //.filter((t) => t.Recd_Payment == 'Yes');
            this.isLoading = false;
            console.log(resSuccess);
          },
          (resErr) => {
            this.isLoading = false;
            this.Errors = resErr;
          }
        );
    }
  }

  isWithinLastWeek(dateStr: string): boolean {
    const fourHoursAgo = new Date(
      this.currentDateTime.getTime() - 4 * 60 * 60 * 1000 // 4 hours in milliseconds
    );
    const targetDate = new Date(dateStr);
    return targetDate >= fourHoursAgo && targetDate <= this.currentDateTime;
  }

  getResult() {
    this.sample.getResults(this.startdate, this.enddate).subscribe(
      (resSuccess:any) => {
        this.data = resSuccess.data;
        this.isLoading = false;
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );
  }

  stat(item) {
    if (item.id == this.clickedId) {
      this.vissible = !this.vissible;
    } else {
      this.vissible = true;
    }
    this.clickedId = item.id;

    this.startLoading = true;
    this.bill.getStats(item.id).subscribe(
      (resSuccess) => {
        this.statResult = resSuccess;
        this.startLoading = false;
        let total = this.statResult.total_samples;
        let collect = this.statResult.samples_collected;
        let acknowledge = this.statResult.samples_acknowledged;
        let type = this.statResult.total_results;
        let finalize = this.statResult.results_finalized;
        let verified = this.statResult.samples_verified;
        let online = this.statResult.pushed_online;
        let printed = this.statResult.printed;
        let reception = this.statResult.result_dispatched_to_reception;
        let patient = this.statResult.result_dispactched_to_patient;
        this.patientName = item.patientName;

        if (total == verified) {
          this.verified = 'green';
        } else {
          this.verified = 'red';
        }
        if (total == patient) {
          this.patient = 'green';
        } else {
          this.patient = 'red';
        }
        if (total == online) {
          this.online = 'green';
        } else {
          this.online = 'red';
        }
        if (total == printed) {
          this.printed = 'green';
        } else {
          this.printed = 'red';
        }
        if (total == reception) {
          this.reception = 'green';
        } else {
          this.reception = 'red';
        }
        if (total == collect) {
          this.collect = 'green';
        } else {
          this.collect = 'red';
        }
        if (total == acknowledge) {
          this.acknowledge = 'green';
        } else {
          this.acknowledge = 'red';
        }
        if (total == type) {
          this.type = 'green';
        } else {
          this.type = 'red';
        }
        if (total == finalize) {
          this.finalize = 'green';
        } else {
          this.finalize = 'red';
        }
        console.log(resSuccess);
      },
      (resErr) => {
        this.Errors = resErr;
      }
    );
  }
  scan() {
    this.modal.openModal(BarcodeComponent, 'modal');
  }

  getSamples(billId) {
    if (this.router.url == '/encounters') {
      // this.editBill(billId);
      this.router.navigateByUrl(`/Result-entry/${billId}`);
      this.resultRoute = true;
    } else if (this.router.url == '/finalise-encounter') {
      this.router.navigateByUrl(`/result-finalize/${billId}`);
      this.finalizeRoute = true;
    } else if (this.router.url == '/result-print') {
      this.router.navigateByUrl(`/result-print/${billId}`);
      this.printRoute = true;
    } else if (this.router.url == '/acknowledge-sample') {
      const data = { bill_id: billId };
      this.acknowledgeRoute = true;
      this.modal.openModal(SampleAcknoledgeModalComponent, 'modal', data);
    } else if (this.router.url == '/collect-sample') {
      const data = { bill_id: billId };
      this.collectRoute = true;
      this.modal.openModal(SampleCollectModalComponent, 'modal', data);
    } else if (this.router.url == '/result-dispatch') {
      this.router.navigateByUrl(`/result-dispatch/${billId}`);
    }
  }

  detail: any;
  detail2: any;
  detail3: any;
  ref: any;

  async editBill(billId) {
    // console.log(this.detail, 'Detaillllllllllllllll');
    this.isLoading = true;
    console.log(billId);

    try {
      const billDetail = await this.bill.getBillDetail(billId).toPromise();
      this.isLoading = false;
      this.detail = billDetail;
      console.log(this.detail);
      console.log(billDetail.registration_no);
      if (this.detail.Recd_Payt != 'Yes') {
        const patientInfo = await this.bill
          .getPatients(billDetail.registration_no)
          .toPromise();
        console.log(patientInfo);
        this.cachebillInfo(billDetail, patientInfo);
        this.detail2 = patientInfo[0]?.date_of_birth;
        this.detail3 = this.detail2.slice(0, 10);

        const refDrResponse = await this.bill
          .getRefDrByCode(patientInfo[0].ref_doct_code)
          .toPromise();
        console.log(refDrResponse);
        this.ref = refDrResponse[0];

        console.log('Detail after getDetail:', this.detail); // Debugging statement

        if (this.detail) {
          this.router.navigateByUrl('/billing');
          console.log('Navigating to billing page');
        } else {
          console.log('Detail not available');
        }
      } else {
        this._snackBar.open(
          `This Bill ${this.detail.bill_no}, is already authorized and cannot be edited.`,
          '',
          {
            duration: 2000,
            verticalPosition: 'top',
          }
        );
      }
    } catch (error) {
      this.Errors = error;
      console.log(error);
      this.isLoading = false;
    }
  }

  cachebillInfo(details, patientInfo) {
    this.auth.currentBillItem(details);
    this.auth.currentPatient(patientInfo);
    // console.log(details, 'firssttttttttttttt');
  }
}
